import { z } from "zod";

export const ArchivedProjectsSchema = z.object({
  projectId: z.string(),
  projectCode: z.string(),
  projectName: z.string(),
  lastDrawCreatedDate: z.coerce.date(),
  archiveDate: z.coerce.date(),
});

export const ArchivedProjectListSchema = z.array(ArchivedProjectsSchema);

export type ArchivedProject = z.infer<typeof ArchivedProjectsSchema>;
